import { render } from "./APPersonalization.vue?vue&type=template&id=98d50072&scoped=true"
import script from "./APPersonalization.vue?vue&type=script&lang=js"
export * from "./APPersonalization.vue?vue&type=script&lang=js"

import "./APPersonalization.vue?vue&type=style&index=0&id=98d50072&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d50072"]])

export default __exports__